import { Maybe } from '@ats/api/cm';
import { filter, Observable } from 'rxjs';
import { AtsUtility } from '../classes/ats-utility.class';

export const filterNullOrUndefined =
	<T = any>(): ((source$: Observable<null | undefined | Maybe<T> | T>) => Observable<T>) =>
	(source$: Observable<null | undefined | Maybe<T> | T>) =>
		source$.pipe(filter(AtsUtility.isNotNullOrUndefined));
